import React, { useEffect, useRef } from 'react';
import { Icon } from 'antd';
import { fileFilter } from '../../help/file';

export interface FileItem {
  name: string;
  id: string;
  file: File;
  url?: string;
  uuid?: string;
}

export interface UploadButtonProps {
  acceptRegexp: RegExp;
  acceptString: string;
  /** 0 不限制，单位 byte */
  maxSize?: number;
  onload: (files: FileItem[]) => void;
  /** 方形 还是 线性，影响样式 */
  type: 'square' | 'line';
  style?: any;
  autoOpenDirectory: boolean;
}

export function UploadButton(props: UploadButtonProps) {
  const input = useRef<HTMLInputElement>(null);

  useEffect(
    () => {
      if (input.current && props.autoOpenDirectory) {
        input.current.click();
      }
    },
    [] as ReadonlyArray<null>
  );

  const onFileChange = (files: FileList) => {
    props.onload(fileFilter(files, props.acceptRegexp, props.maxSize));
  };

  const squareStyle = {
    display: 'flex',
    border: `1px dashed ${alo7Theme.primaryColor}`,
    width: '115px',
    height: '98px',
    position: 'relative',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const lineStyle: any = {
    display: 'flex',
    border: `1px solid ${alo7Theme.primaryColor}`,
    width: '100%',
    height: '32px',
    borderRadius: '4px',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  };

  return (
    <div
      style={{
        ...(props.type === 'square' ? squareStyle : lineStyle),
        ...props.style,
      }}>
      <Icon
        type={'plus'}
        style={{
          fontSize: props.type === 'square' ? '36px' : '20px',
          color: alo7Theme.primaryColor,
        }}
      />
      {props.type === 'line' && (
        <span style={{ color: alo7Theme.primaryColor, marginLeft: '0.5em' }}>
          添加文件
        </span>
      )}
      <input
        ref={input}
        multiple={true}
        accept={props.acceptString}
        type={'file'}
        onChange={(e: any) => {
          onFileChange(e.nativeEvent.target.files);
          e.target.value = null;
        }}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          opacity: 0,
          cursor: 'pointer',
        }}
      />
    </div>
  );
}
